// extracted by mini-css-extract-plugin
export default {"container":"TemperatureIndicator_container__EE1sn","text":"TemperatureIndicator_text__dHJGe","degrees":"TemperatureIndicator_degrees__nV1r5"};